import api from "../config/api";

export const getTripsByVendorId = async (vendor_id = "", status = "") => {
  let url = "/trip/";
  const params = new URLSearchParams();
  if (vendor_id) params.append("vendor_id", vendor_id);
  if (status) params.append("status", status);

  if ([...params].length) url += "?" + params.toString();

  const response = await api.get(url);
  return response.data;
};

export const getAllTrips = async (page = 1, limit = 10) => {
  const response = await api.get(`/trip/?page=${page}&limit=${limit}`);
  return response.data;
}

export const getTripById = async (id) => {
  const response = await api.get(`/trip/?id=${id}`);
  return response.data;
};

export const saveTrip = async (data) => {
  const response = await api.post("/trip/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};

export const deleteTrip = async (id) => {
  const response = await api.delete(`/trip/?id=${id}`);
  return response.data;
};
export const filterTrips = async ({
  vendor_id = "",
  vehicle_id = "",
  from_date = "",
  to_date = "",
  status = ""
} = {}) => {
  const params = new URLSearchParams();
  if (vendor_id) params.append("vendor_id", vendor_id);
  if (vehicle_id) params.append("vehicle_id", vehicle_id);
  if (from_date) params.append("from_date", from_date);
  if (to_date) params.append("to_date", to_date);
  if (status) params.append("status", status);

  const url = `/trip/filter/?${params.toString()}`;
  const response = await api.get(url);
  return response.data;
};

